import { signal } from 'kerfjs';

/** The app bar's story search field (kerf UI `SearchField`). */
export const SEARCH_FIELD_ID = 'feed-search';
/**
 * Whether the collapsible search is open while empty — transient state that
 * `wireSearchFields` manages (open on activate, close on Escape or an
 * empty blur); a field holding a query stays open regardless.
 */
export const searchExpanded = signal(false);
/** The resolved color scheme (pinned theme or system), kept by `syncColorScheme` — the app bar's tint declares it (NM-DV3RKT). */
export const schemeDark = signal(false);
/**
 * The search editor's identity for a programmatic text replacement: the
 * editor's text is DOM-owned between renders, so clearing the query alone would
 * leave the old text on screen. Bumped by the clear action.
 */
export const searchRevision = signal(0);
